var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h3',[_vm._v("Gestione percorsi")]),_c('ul',[_c('li',[_vm._v("Aggiungi/Rimuovi percorso")]),_c('li',[_vm._v("Aggiungi/Rimuove tappe al percorso ")]),_c('li',[_vm._v("Drag & Drop per riordinarle ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }